import { BaseComponent } from '../../base-component';
import { waitForAllPreloadedScriptsToBeLoaded } from '../../_common/client/otto-preloaded-scripts-helper';

export class ShareBtnComponent extends BaseComponent {
    public rootSelector = '.js_pdp_share-btn';

    private shareType: 'webshareapi' | 'native' | undefined;

    public async init(): Promise<void> {
        // o_apps is not loaded sometimes at this moment
        await waitForAllPreloadedScriptsToBeLoaded();

        if (!!window.navigator.share) {
            this.shareType = 'webshareapi';
        } else if (!!window.o_apps?.shareNative) {
            this.shareType = 'native';
        }
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.shareType) {
            this.hide();
            return;
        }

        const isAndroid = o_global.device.os == 'Android';
        // any non-android device has ios icon
        this.setIcon(isAndroid ? 'share' : 'share-ios');

        this.getRootElement().addEventListener('click', () => this.doShare());

        const isValidVariation = this.getRootElement().dataset.isValidVariation === 'true';

        const shouldShow = isValidVariation && !!this.shareType;

        shouldShow ? this.show() : this.hide();
    }

    public async doShare(): Promise<void> {
        const shareUrl = this.createShareUrl();

        switch (this.shareType) {
            case 'native':
                await this.doShareNative(shareUrl);
                break;
            case 'webshareapi':
                await this.doShareWebShareApi(shareUrl);
                break;
            default:
                throw Error(`unknown share type: ${this.shareType}`);
        }
    }

    /**
     * share over mobile device native share
     * api: https://github.com/otto-ec/apps_documentation/blob/main/javascript_api/shareNative.md
     */
    private async doShareNative(url: string): Promise<void> {
        o_apps?.shareNative?.({ url: url, type: 'product' });
    }

    /**
     * share over browser share api
     */
    private async doShareWebShareApi(url: string): Promise<void> {
        const shareData = {
            title: 'OTTO',
            text: 'Schau mal, was ich bei OTTO gefunden habe – was hältst du davon? ',
            url: url,
        };
        await navigator.share(shareData);
    }

    private createShareUrl(): string {
        const variationId = this.getVariationId();
        const shareType = this.getShareTypeForUrl();
        return `${window.location.origin}/p/share/${shareType}/${variationId}`;
    }

    private getShareTypeForUrl(): string {
        switch (this.shareType) {
            case 'native':
                return 'n';
            default:
                return 'w';
        }
    }

    private setIcon(iconId: string): void {
        this.getRootElement().setAttribute('icon-type-left', iconId);
    }
}
